import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

/** Mesero del negocio (espejo del backend multi-tenant, F5). */
export interface WaiterAdmin {
  id: number;
  name: string;
  active: boolean;
  dailySaleGoal: number | null;
  defaultCashBase: number | null;
  /** Si ya tiene clave (lo manda el servidor; ausente = backend anterior). */
  tienePin?: boolean;
}

/**
 * Administración de meseros desde el POS (F5, cluster meseros): reemplaza el
 * snippet de consola de la guía. Solo lo usa la UI de admin (sidebar).
 */
@Injectable({ providedIn: 'root' })
export class WaiterAdminService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/waiter/mobile/waiters`;

  getAll(): Promise<WaiterAdmin[]> {
    return firstValueFrom(this.http.get<WaiterAdmin[]>(`${this.base}?all=true`));
  }

  create(name: string, dailySaleGoal: number | null, defaultCashBase: number | null): Promise<WaiterAdmin> {
    return firstValueFrom(this.http.post<WaiterAdmin>(this.base, { name, dailySaleGoal, defaultCashBase }));
  }

  update(id: number, patch: Partial<Pick<WaiterAdmin, 'name' | 'active' | 'dailySaleGoal' | 'defaultCashBase'>>): Promise<WaiterAdmin> {
    return firstValueFrom(this.http.put<WaiterAdmin>(`${this.base}/${id}`, patch));
  }

  /**
   * A9 (-mt cc7d87d): el administrador pone o cambia la clave de un mesero sin saber la actual. La primera clave solo
   * la puede poner un admin (a otro el servidor le responde 403 PIN_SOLO_ADMIN).
   */
  ponerClave(id: number, pinNuevo: string): Promise<void> {
    return firstValueFrom(this.http.post<void>(`${this.base}/${id}/pin`, { pinNuevo }));
  }
}
